module.exports = __webpack_public_path__ + "584c295efde4faaa4728de4cea913cbd.jpg";